import { seoByLocale, termsByLocale } from "../content";
import { LegalPage } from "../components/LegalPage";
import { SiteLayout } from "../components/SiteLayout";
import type { Locale } from "../content/types";
import { usePageSeo } from "../lib/seo";

type TermsPageProps = {
  locale: Locale;
};

export function TermsPage({ locale }: TermsPageProps) {
  usePageSeo({ locale, routeKind: "terms", seo: seoByLocale[locale].terms });

  return (
    <SiteLayout locale={locale} page="terms">
      <div className="legal-page">
        <LegalPage content={termsByLocale[locale]} />
      </div>
    </SiteLayout>
  );
}
